import fileTypes from 'constants/file-types';
import { determineFileType } from 'utilities/file';

function generateCssFilter(filterObject) {
  const {
    opacity,
    hue,
    saturation,
    brightness,
    contrast,
    blur,
    filterType
  } = filterObject;

  let filterCss = '';

  // Adding the filter type (e.g., sepia, grayscale, etc.)
  if (filterType) {
    filterCss += `${filterType.toLowerCase()}(50%) `;
  }

  // Adding the rest of the filter properties
  if (saturation) {
    filterCss += `saturate(${saturation}%) `;
  }

  if (brightness) {
    filterCss += `brightness(${brightness}%) `;
  }

  if (contrast) {
    filterCss += `contrast(${contrast}%) `;
  }

  if (hue) {
    filterCss += `hue-rotate(${hue}deg) `;
  }

  if (blur) {
    filterCss += `blur(${blur}px) `;
  }

  if (opacity) {
    filterCss += `opacity(${opacity}%) `;
  }

  return filterCss.trim(); // Trim to remove any trailing space
}

export function getFileContainerClassName(element) {

  const attributes = element.attributes;

  let className = 'image-file-container';

  if (typeof attributes.clip === 'string') {
    className += ` ${attributes.clip}`;
  }

  if (typeof attributes.fit === 'string') {
    className += ` fit-${attributes.fit}`;
  }

  return className;

}

export function getStyles(attributes) {

  const styles = {
    marginLeft: attributes.marginLeft || 0,
    marginRight: attributes.marginRight || 0
  };

  if (styles.marginRight === void 0) {
    delete styles.marginRight;
  }

  if (styles.marginLeft === void 0) {
    delete styles.marginLeft;
  }

  const filterCss = generateCssFilter(attributes.attributes);

  if (filterCss !== '') {
    styles.filter = filterCss;
  }

  return styles;

}

export function determineFileAndType(attributes) {

  const file = attributes.file;
  let _file = file;
  let _fileType;
  let mimetype = _file.mimetype;

  if (_file === void 0) {
    _file = { url: 'https://cdn.venturz.co/images/default-image-placeholder-icon.svg', mimetype: 'image/svg+xml', name: 'Placeholder' };
  } else if (attributes.fileType === fileTypes.IMAGE && mimetype === void 0) {
    mimetype = 'image/jpg';
  }

  _fileType = determineFileType({ type: mimetype });

  if (_fileType === void 0) {
    _fileType = fileTypes.DOCUMENT;
  }

  return { file: _file, fileType: _fileType };

}
